'use client'

export function localStorageSetItems(dto: { [key: string]: string }) {
    const keys: string[] = Object.keys(dto);

    if (keys.length > 0) {
        for (let i = 0; i < keys.length; i++) {
            localStorage.setItem(keys[i], dto[keys[i]]);
        }

        return true;
    }

    return false;
}

export function localStorageGetItems(keys: string[]) {

    if (typeof window === 'undefined') return {};

    let result: { [key: string]: string } = {};

    for (let i = 0; i < keys.length; i++) {
        const value = localStorage.getItem(keys[i]);
        if (value) {
            result[keys[i]] = value;
        }
    }

    return result;
}

export function localStorageRemoveItems(keys: string[]) {
    for (let i = 0; i < keys.length; i++) {
        localStorage.removeItem(keys[i]);
    }
}
